import { Ref, watch, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import { useEventBus } from '../use-event-bus/use-event-bus';

/**
 * Composable to synchronize dropdown state across multiple dropdowns.
 * When one dropdown opens, all others close automatically.
 *
 * @param isOpen - A reactive ref controlling the open/closed state of the dropdown
 */
export function useDropdownSync(isOpen: Ref<boolean>) {
  const instance = getCurrentInstance();
  const proxy = instance?.proxy;
  const eventBus = useEventBus();

  // Listen for modal opens and other dropdown opens
  onMounted(() => {
    // Close dropdown when a modal opens
    eventBus.$on('modalOpen', () => {
      isOpen.value = false;
    });

    // Close dropdown when another dropdown opens
    eventBus.$on('dropdown-opened', (uid: number) => {
      // If another dropdown opened, close this one
      if (uid !== proxy._uid && isOpen.value) {
        isOpen.value = false;
      }
    });
  });

  // Emit event when this dropdown opens
  watch(isOpen, (isNowOpen) => {
    if (isNowOpen) {
      eventBus.$emit('dropdown-opened', proxy._uid);
    }
  });

  // Clean up event listeners
  onBeforeUnmount(() => {
    eventBus.$off('modalOpen');
    eventBus.$off('dropdown-opened');
  });
}
